module.exports = __webpack_public_path__ + "static/object-5-63b320b3a0984469863ca50519d0a188.png";